import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that scrolls window to top on route change
 * Used to ensure mobile users always start at the top of new pages
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
